import { AppBar, Avatar, Badge, Box, Button, CircularProgress, Dialog, Tooltip, DialogActions, DialogContent, DialogContentText, DialogTitle, IconButton, Popover, Slide, Slider, Toolbar, Typography } from '@mui/material';
import { alpha } from '@mui/material/styles';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import DeleteSweepIcon from '@mui/icons-material/DeleteSweep';
import ExitToAppIcon from '@mui/icons-material/ExitToApp';
import MenuIcon from '@mui/icons-material/Menu';
import MenuOpenIcon from '@mui/icons-material/MenuOpen';
import NotificationsActiveIcon from '@mui/icons-material/NotificationsActive';
import WarningAmberIcon from '@mui/icons-material/WarningAmber';
import PropTypes from 'prop-types';
import React, { useEffect, useRef, useState } from 'react';
import { confirmAlert } from 'react-confirm-alert';
import { connect } from 'react-redux';
import { useNavigate } from 'react-router';
import NotificationsPopover from 'src/components/NotificationsPopover';
import { getNotifications, notifyNotificationViewed } from 'src/store/api/notificationsApi';
import { getSepetAdet, getUser, handleLogoutMain } from 'src/utils/Common';
import { baseURL } from 'src/utils/contants';
import { closeAlert, getTasksRequest } from '../../store/actions';
import { useOktaAuth } from '@okta/okta-react';
import SmartToyIcon from '@mui/icons-material/SmartToy';

const getInitials = (name) => {
  if (!name) return '?';
  const parts = name.trim().split(/\s+/);
  const first = parts[0]?.[0] || '';
  const last = parts.length > 1 ? parts[parts.length - 1][0] : '';
  return (first + last).toUpperCase();
};

const styles = {
  root: {
    boxShadow: 'none',
  },
  menuButton: {
    marginRight: '4px'
  },
  iconButton: {
    color: '#fff'
  },
  table: {
    minWidth: 600
  },
  flexGrow: {
    flexGrow: 1
  },
  title: (theme) => ({
    flexGrow: 1,
    marginBottom: theme.spacing(-1),
    marginLeft: theme.spacing(1)
  }),
  search: (theme) => ({
    position: 'relative',
    borderRadius: theme.shape.borderRadius,
    backgroundColor: alpha(theme.palette.common.white, 0.15),
    '&:hover': {
      backgroundColor: alpha(theme.palette.common.white, 0.25),
    },
    marginLeft: 0,
    width: '100%',
    [theme.breakpoints.up('sm')]: {
      marginLeft: theme.spacing(1),
      width: 'auto',
    },
  }),
  searchIcon: (theme) => ({
    padding: theme.spacing(0, 2),
    height: '100%',
    position: 'absolute',
    pointerEvents: 'none',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  }),
  inputRoot: {
    color: 'inherit',
  },
  inputInput: (theme) => ({
    padding: theme.spacing(1, 1, 1, 0),
    // vertical padding + font size from searchIcon
    paddingLeft: `calc(1em + ${theme.spacing(4)}px)`,
    transition: theme.transitions.create('width'),
    width: '100%',
    [theme.breakpoints.up('sm')]: {
      width: '12ch',
      '&:focus': {
        width: '20ch',
      },
    },
  }),
  infoChip: {
    display: 'flex',
    alignItems: 'center',
    gap: 0.5,
    px: 1,
    py: 0.35,
    borderRadius: 1.5,
    cursor: 'default',
  },
  avatarButton: {
    padding: 0.5,
    borderRadius: 8,
    border: '2px solid transparent',
    transition: 'all 0.2s ease',
    '&:hover': {
      borderColor: 'rgba(255, 152, 0, 0.5)',
      backgroundColor: 'rgba(255, 152, 0, 0.1)',
    },
  },
  avatar: {
    width: 32,
    height: 32,
    border: '2px solid rgba(255, 152, 0, 0.4)',
    bgcolor: '#FFF3E0',
    color: '#FF9800',
    fontSize: '0.85rem',
    fontWeight: 700,
  },
};
const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});
function TopBar({ onOpenNavBar, openNavBar, className, getTasksRequest, alertReducer, closeAlert }) {
  const navigate = useNavigate();
  const notificationsRef = useRef(null);
  const [notifications, setNotifications] = useState([]);
  const [showNotificationList, setShowNotificationList] = useState(false);
  const [sepetAdetDeger, setSepetAdetDeger] = useState(0);
  const [FiyatDegisiklikAdet, setFiyatDegisiklikAdet] = useState(0);
  const [openBasket, setopenBasket] = useState(false);
  const [openFiyatDegisiklik, setopenFiyatDegisiklik] = useState(false);
  const [Counting, setCounting] = useState(false);
  const [SepetData, setSepetData] = useState([]);
  const [FiyatData, setFiyatData] = useState([]);
  const SessionUser = getUser();
  const { oktaAuth } = useOktaAuth();

  const [userMenuAnchorEl, setUserMenuAnchorEl] = useState(null);
  const userMenuOpen = Boolean(userMenuAnchorEl);
  const [fontSize, setFontSize] = useState(() => parseInt(localStorage.getItem('appFontSize')) || 15);
  const [clearCacheDialogOpen, setClearCacheDialogOpen] = useState(false);
  const [clearingCache, setClearingCache] = useState(false);
  const [clearCacheSuccess, setClearCacheSuccess] = useState(false);

  const FONT_SIZE_BASELINE = 15;

  useEffect(() => {
    document.documentElement.style.setProperty('--app-font-scale', fontSize / FONT_SIZE_BASELINE);
  }, [fontSize]);

  const handleFontSizeChange = (event, newValue) => {
    setFontSize(newValue);
    localStorage.setItem('appFontSize', newValue);
  };

  const handleClearCache = () => {
    setClearCacheDialogOpen(true);
    setClearCacheSuccess(false);
  };

  const handleClearCacheConfirm = async () => {
    setClearingCache(true);
    try {
      try {
        const dbs = await window.indexedDB.databases();
        for (const db of dbs) {
          if (db.name) window.indexedDB.deleteDatabase(db.name);
        }
      } catch { /* eski tarayıcı desteği */ }

      localStorage.clear();
      sessionStorage.clear();

      try {
        const cacheNames = await caches.keys();
        await Promise.all(cacheNames.map((name) => caches.delete(name)));
      } catch { /* ignored */ }

      setClearingCache(false);
      setClearCacheSuccess(true);

      setTimeout(() => {
        window.location.href = '/';
      }, 1200);
    } catch (e) {
      setClearingCache(false);
      localStorage.clear();
      sessionStorage.clear();
      window.location.href = '/';
    }
  };

  const handleClickNotification = ({ ID, Url }) => {
    setShowNotificationList(false);
    //notify server that was read
    notifyNotificationViewed(ID);
    getTasksRequest();
    if (Url.match(baseURL)) {
      navigate(Url.replace(baseURL, ''));
    } else {
      window.open(Url, '_blank');
    }
    //remove clicked notification
    setNotifications(notifications => notifications.filter(notification => notification.ID !== ID));
  };
  const handleCloseBasket = () => {
    setopenBasket(false);
  };
  const handleCloseFiyatDegisiklik = () => {
    setopenFiyatDegisiklik(false);
  };
  const handleCloseCounting = () => {
    setCounting(false);
  };

  var Deger = getSepetAdet();

  useEffect(() => {
    var Deger = getSepetAdet();
    setSepetAdetDeger(Deger);
    if (SessionUser?.Counting === 1) {
      setCounting(true);
    }

  }, [Deger]);

  const handleDeleteAll = () => {
    setShowNotificationList(false)
    confirmAlert({
      message: "Tüm Bildirimleriniz Silinecektir. Onaylıyor Musunuz?",
      buttons: [
        {
          label: 'Evet',
          onClick: () => deleteYes()
        },
        {
          label: 'Hayır',
          onClick: () => { return; }
        }
      ]
    });
    const deleteYes = () => {
      notifications.forEach(e => {
        notifyNotificationViewed(e.ID);
      });
      getNotifications()
        .then(res => {
          Array.isArray(res.data) && setNotifications(res.data);
        });
    }
  }
  const setMenuShowFnc = () => {
    onOpenNavBar();
  }

  const Beyaz = {
    color: '#FFFFFF'
  };

  const Logout = async () => {
    handleLogoutMain();
    await oktaAuth.signOut();

  };

  const handleChatBotLink = () => {
    const chatbotUrl = SessionUser?.Role_Id === 10
      ? "https://apollochatbot.beko.com/"
      :  "https://servicemate.beko.com/";
    window.open(chatbotUrl, "_blank");
  };

  const canAccessChatbot = !!SessionUser && (
    SessionUser.Role_Id !== 4 &&
    SessionUser.Role_Id !== 11 &&
    !(SessionUser.Role_Id === 9 && (SessionUser.ManagementRoleId !== 1 && SessionUser.ManagementRoleId !== 2))
  );

  return (
    <AppBar
      className={className}
      sx={[styles.root, { background: '#424242' }]}
    >
      <Toolbar>
        <IconButton
          style={{ ...styles.menuButton, ...Beyaz }}
          onClick={setMenuShowFnc}>
          {openNavBar ? <MenuIcon /> : <MenuOpenIcon />}
        </IconButton>
        <Typography
          variant="h4"
          component="h3"
          style={{ fontFamily: 'AssistantRegular', color: '#FF9800', paddingTop: 3 }}
        >
          apollo
        </Typography>
        <Typography variant="h6" sx={styles.title}>

        </Typography>

        <Box
          sx={[styles.infoChip, {
            display: { xs: 'none', sm: 'flex' },
            bgcolor: 'rgba(16, 185, 129, 0.2)',
            border: '1px solid rgba(52, 211, 153, 0.4)',
            mr: 1,
          }]}
        >
          <Box sx={{ width: 6, height: 6, borderRadius: '50%', bgcolor: '#34d399', boxShadow: '0 0 6px rgba(52, 211, 153, 0.6)' }} />
          <Typography component="span" sx={{ fontSize: '0.65rem', fontWeight: 700, color: '#a7f3d0', letterSpacing: 0.3 }}>
            v{process.env.REACT_APP_VERSION || '1.0.0'}
          </Typography>
        </Box>

        <Tooltip title={`Sunucu: ${window.APP_CONFIG?.serverName || 'Bilinmiyor'}`} arrow>
          <Box
            sx={[styles.infoChip, {
              display: { xs: 'none', sm: 'flex' },
              bgcolor: 'rgba(251, 191, 36, 0.2)',
              border: '1px solid rgba(251, 191, 36, 0.4)',
              mr: 1,
            }]}
          >
            <Box sx={{ width: 6, height: 6, borderRadius: '50%', bgcolor: '#fbbf24', boxShadow: '0 0 6px rgba(251, 191, 36, 0.6)' }} />
            <Typography component="span" sx={{ fontSize: '0.65rem', fontWeight: 700, color: '#fde68a', letterSpacing: 0.3 }}>
              {window.APP_CONFIG?.serverName || 'N/A'}
            </Typography>
          </Box>
        </Tooltip>

        {canAccessChatbot ?
          <Tooltip title="Chatbot linkine yönlendirileceksiniz!...">
            <IconButton
              style={styles.iconButton}
              onClick={handleChatBotLink}
              ref={notificationsRef}
            >
              <Badge
                style={Beyaz}
              >
                <SmartToyIcon sx={{ color: '#FF9800' }} />
              </Badge>
            </IconButton>
          </Tooltip>
          : null}
        <IconButton
          style={styles.iconButton}
          onClick={() => setShowNotificationList(true)}
          ref={notificationsRef}
        >
          <Badge
            style={Beyaz}
            badgeContent={notifications.length}
          >
            <NotificationsActiveIcon color="primary" />
          </Badge>
        </IconButton>
        <Tooltip title={SessionUser?.NameSurname || ''} arrow>
          <IconButton
            sx={[styles.avatarButton, { ml: 1 }]}
            onClick={(event) => setUserMenuAnchorEl(event.currentTarget)}
          >
            <Avatar sx={styles.avatar}>{getInitials(SessionUser?.NameSurname)}</Avatar>
          </IconButton>
        </Tooltip>
      </Toolbar>

      <Popover
        open={userMenuOpen}
        anchorEl={userMenuAnchorEl}
        onClose={() => setUserMenuAnchorEl(null)}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
        transformOrigin={{ vertical: 'top', horizontal: 'right' }}
        slotProps={{ paper: { sx: { width: 320, borderRadius: '16px', overflow: 'hidden' } } }}
      >
        <Box sx={{ background: 'linear-gradient(135deg, #FF9800 0%, #FFB74D 100%)', p: 2 }}>
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
            <Avatar sx={{ width: 48, height: 48, bgcolor: 'rgba(255,255,255,0.25)', color: '#fff', fontWeight: 700, border: '2px solid rgba(255,255,255,0.5)' }}>
              {getInitials(SessionUser?.NameSurname)}
            </Avatar>
            <Box sx={{ minWidth: 0 }}>
              <Typography sx={{ fontWeight: 600, color: 'white', fontSize: '0.95rem', lineHeight: 1.3 }}>
                {SessionUser?.NameSurname || 'Kullanıcı'}
              </Typography>
              <Typography sx={{ color: 'rgba(255,255,255,0.85)', fontSize: '0.75rem' }}>
                {SessionUser?.ServiceShopCode} {SessionUser?.ServiceShopName ? `• ${SessionUser.ServiceShopName}` : ''}
              </Typography>
            </Box>
          </Box>
        </Box>

        <Box sx={{ p: 2 }}>
          <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 0.5 }}>
            <Typography sx={{ fontSize: '0.7rem', fontWeight: 600, color: '#94a3b8', letterSpacing: 0.5 }}>
              Yazı Boyutu
            </Typography>
            <Typography sx={{ fontSize: '0.7rem', fontWeight: 600, color: '#FF9800' }}>
              {fontSize}px
            </Typography>
          </Box>
          <Slider
            value={fontSize}
            min={12}
            max={18}
            onChange={handleFontSizeChange}
            size="small"
            sx={{
              color: '#FF9800',
              '& .MuiSlider-thumb': { width: 14, height: 14 },
            }}
          />
        </Box>

        <Box sx={{ p: 2, pt: 0, display: 'flex', gap: 1.5 }}>
          <Button
            variant="outlined"
            startIcon={<DeleteSweepIcon sx={{ fontSize: 20 }} />}
            onClick={handleClearCache}
            sx={{
              flex: 1,
              textTransform: 'none',
              fontSize: '0.8rem',
              fontWeight: 600,
              color: '#d97706',
              borderColor: alpha('#d97706', 0.4),
              borderRadius: '10px',
            }}
          >
            Önbellek Temizle
          </Button>
          <Button
            variant="contained"
            startIcon={<ExitToAppIcon sx={{ fontSize: 20, color: '#ffffff' }} />}
            onClick={() => { setUserMenuAnchorEl(null); Logout(); }}
            sx={{
              flex: 1,
              textTransform: 'none',
              fontSize: '0.85rem',
              fontWeight: 600,
              borderRadius: '10px',
              backgroundColor: '#dc2626',
              '&:hover': { backgroundColor: '#b91c1c' },
            }}
          >
            Çıkış Yap
          </Button>
        </Box>
      </Popover>

      <Dialog
        open={clearCacheDialogOpen}
        onClose={() => !clearingCache && setClearCacheDialogOpen(false)}
        maxWidth="xs"
        fullWidth
      >
        <Box sx={{
          background: clearCacheSuccess
            ? 'linear-gradient(135deg, #10b981 0%, #059669 100%)'
            : 'linear-gradient(135deg, #f59e0b 0%, #d97706 100%)',
          p: 3,
          textAlign: 'center',
        }}>
          {clearCacheSuccess ? (
            <CheckCircleOutlineIcon sx={{ fontSize: 56, color: '#ffffff' }} />
          ) : clearingCache ? (
            <CircularProgress size={56} sx={{ color: '#ffffff' }} thickness={4} />
          ) : (
            <WarningAmberIcon sx={{ fontSize: 56, color: '#ffffff' }} />
          )}
          <Typography sx={{ mt: 1.5, fontWeight: 700, fontSize: '1.15rem', color: '#ffffff' }}>
            {clearCacheSuccess ? 'Önbellek Temizlendi!' : clearingCache ? 'Temizleniyor...' : 'Önbellek Temizle'}
          </Typography>
          <Typography sx={{ mt: 0.5, fontSize: '0.8rem', color: 'rgba(255,255,255,0.85)' }}>
            {clearCacheSuccess
              ? 'Giriş sayfasına yönlendiriliyorsunuz'
              : clearingCache
                ? 'Lütfen bekleyiniz'
                : 'Bu işlem geri alınamaz, oturumunuz kapanacaktır'}
          </Typography>
        </Box>
        {!clearCacheSuccess && !clearingCache && (
          <Box sx={{ p: 2, display: 'flex', gap: 1.5 }}>
            <Button
              fullWidth
              variant="outlined"
              onClick={() => setClearCacheDialogOpen(false)}
              sx={{ py: 1.2, borderRadius: '12px', textTransform: 'none', fontWeight: 600 }}
            >
              Vazgeç
            </Button>
            <Button
              fullWidth
              variant="contained"
              onClick={handleClearCacheConfirm}
              startIcon={<DeleteSweepIcon />}
              sx={{
                py: 1.2,
                borderRadius: '12px',
                textTransform: 'none',
                fontWeight: 600,
                background: 'linear-gradient(135deg, #f59e0b 0%, #d97706 100%)',
              }}
            >
              Temizle ve Çıkış Yap
            </Button>
          </Box>
        )}
      </Dialog>

      <NotificationsPopover
        anchorEl={notificationsRef.current}
        notifications={notifications}
        onClickNotification={handleClickNotification}
        onClose={() => setShowNotificationList(false)}
        open={showNotificationList}
        handleDeleteAll={handleDeleteAll}
      />
      <Dialog
        open={alertReducer.open}
        onClose={() => closeAlert()}
      >
        <DialogTitle color="primary">{alertReducer.title}</DialogTitle>
        <DialogContent>
          <DialogContentText >
            {alertReducer.message}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button
            onClick={() => closeAlert()}
            color="primary">
            Tamam
          </Button>
        </DialogActions>
      </Dialog>
    </AppBar>
  );
}

TopBar.propTypes = {
  alertReducer: PropTypes.shape({
    message: PropTypes.string,
    open: PropTypes.bool,
    title: PropTypes.string
  }),
  className: PropTypes.string,
  closeAlert: PropTypes.func,
  getTasksRequest: PropTypes.func,
  onOpenNavBar: PropTypes.func,
  openNavBar: PropTypes.bool
};

export default connect(
  state => ({ alertReducer: state.alertReducer }),
  {
    getTasksRequest, closeAlert
  }
)(TopBar);
